/**
 * Reads a mock/API env flag. When unset:
 * - local dev (`import.meta.env.DEV`) → defaults to mock (true)
 * - production build → defaults to real API (false)
 * Explicit "true" / "false" always wins.
 */
export function readEnvMockFlag(
  envValue: string | undefined,
  devDefault = true
): boolean {
  if (envValue === "true") return true;
  if (envValue === "false") return false;
  return import.meta.env.DEV && devDefault;
}
